import React from 'react';
export function LoginBackIcon() {
    return (React.createElement("svg", { viewBox: "0 0 16 16", width: "16", height: "16" },
        React.createElement("path", { fill: "currentColor", d: "M6 9h8V8H6V5L2 8.5 6 12z" })));
}
//# sourceMappingURL=LoginBackIcon.js.map